import { faArrowDown, faArrowUp, faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const STYLE = { fontSize: 11, marginLeft: 4, color: 'var(--text-color-neutral-secondary)' };

/** Sort indicators rendered next to a sortable column header, shared by every App table. */
export const SORT_ICON_ASC = <FontAwesomeIcon icon={faArrowUp} style={STYLE} />;
export const SORT_ICON_DESC = <FontAwesomeIcon icon={faArrowDown} style={STYLE} />;
/** Sortable column the list is not currently sorted on. */
export const SORT_ICON_NONE = <FontAwesomeIcon icon={faArrowUpArrowDown} style={STYLE} />;
